import { useEffect, useSyncExternalStore } from "react";

import { useSocketContext } from "@/context/SocketContext";

import { getUnreadState, subscribeUnread } from "./unreadStore";
import {
  startUnreadSources,
  stopUnreadSources,
  updateUnreadSources,
} from "./unreadSources";

/**
 * Счётчики непрочитанного: { notices: {count, latest}, messenger: {count} }.
 * Первый вызов подключает источники, последний отключает.
 * @param {object} [config] — конфиг сайта (адрес мессенджера для проверки сообщений)
 */
export default function useUnread(config) {
  const socket = useSocketContext()?.socket ?? null;

  useEffect(() => {
    startUnreadSources();
    return stopUnreadSources;
  }, []);

  useEffect(() => {
    updateUnreadSources({ socket, config });
  }, [socket, config]);

  return useSyncExternalStore(subscribeUnread, getUnreadState);
}
